"use client"
import { Link } from "react-router-dom"
import Logo from "../../images/Logo.png"
import DarkMode from "./DarkMode"
import { DropdownLinks } from "../../Data"
import { FaCaretDown, FaUser } from "react-icons/fa"

const Navbar = () => {
  return (
    <div className="shadow-md bg-white dark:bg-gray-900 dark:text-white duration-200 relative z-40">
      {/* Upper Navbar */}
      <div className="bg-primary/90 py-2">
        <div className="container mx-auto flex justify-between items-center px-4">
          <div className="flex items-center">
            <Link to="/" className="text-2xl sm:text-3xl flex gap-2 items-center">
              <div className="bg-white rounded-full p-1 hover:scale-105 transition-transform duration-300">
                <img src={Logo || "/placeholder.svg"} alt="Logo" className="logo w-12 md:w-16 rounded-full" />
              </div>
              <span style={{ fontWeight: "bold", color: "White" }}>IIChE AVVU SC</span>
            </Link>
          </div>
          <div className="flex items-center gap-4">
            <DarkMode />
            <Link
              to="/signin"
              className="flex items-center gap-2 text-white hover:text-gray-300 transition-colors duration-200"
            >
              <FaUser />
              <span>Sign In</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Lower Navbar */}
      <div data-aos="zoom-in" className="flex justify-center bg-white dark:bg-gray-900 shadow-md">
        <ul className="container mx-auto flex flex-wrap justify-center items-center gap-2 sm:gap-4 px-4 py-2">
          <li>
            <Link to="/" className="inline-block px-2 sm:px-4 hover:text-primary duration-200">
              Home
            </Link>
          </li>
          <li>
            <Link to="/aboutiiche" className="inline-block px-2 sm:px-4 hover:text-primary duration-200">
              About IIChE
            </Link>
          </li>
          <li>
            <Link to="/studentchapter" className="inline-block px-2 sm:px-4 hover:text-primary duration-200">
              Student Chapter
            </Link>
          </li>
          <li>
            <Link to="/department" className="inline-block px-2 sm:px-4 hover:text-primary duration-200">
              Department
            </Link>
          </li>

          {/* Committees Dropdown */}
          <li className="group relative cursor-pointer">
            <Link to="" className="flex items-center gap-[2px] py-2 px-2 sm:px-4">
              Committees
              <span>
                <FaCaretDown className="transition-all duration-200 group-hover:rotate-180" />
              </span>
            </Link>
            <div className="absolute z-[9999] hidden group-hover:block w-[200px] rounded-md bg-white dark:bg-gray-800 p-2 text-black dark:text-white shadow-md border border-gray-200 dark:border-gray-700">
              <ul>
                {DropdownLinks.map((data) => (
                  <li key={data.id}>
                    <a
                      href={data.link}
                      className="inline-block w-full rounded-md p-2 hover:bg-primary/20 transition-colors duration-200"
                    >
                      {data.Name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </li>

          {/* Events */}
          <li>
            <Link to="/events" className="inline-block px-2 sm:px-4 hover:text-primary duration-200">
              Events
            </Link>
          </li>

          {/* EC Link - Now goes to years selection page */}
          <li>
            <Link to="/ec" className="inline-block px-2 sm:px-4 hover:text-primary duration-200">
              EC
            </Link>
          </li>

          {/* Contact */}
          <li>
            <Link to="/contact" className="inline-block px-2 sm:px-4 hover:text-primary duration-200">
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Navbar
